import React from 'react';

const SVG = ({ style = {}, colors, width = '100%', viewBox = '0 0 400 400' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <ellipse cx="200" cy="350" rx="120" ry="50" fill={colors.dark} />
      <rect x="80" y="50" width="240" height="300" fill={colors.dark} />
      <ellipse cx="200" cy="50" rx="120" ry="50" fill={colors.light} />
    </g>
  </svg>
);

export default SVG;
